import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface GetCelebritiesArgs {
  locale: string
}

export interface CelebritiesDto {
  data: {
    id: number
    attributes: {
      celebrities_title: string
      celebrities_button_text: string
      celebrities: {
        data: CelebrityDto[]
      }
    }
  }
  meta: Record<string, unknown>
}

export interface CelebrityDto {
  id: number
  attributes: {
    name: string
    profession: string | null
    short_text: string
    full_text: BlocksContent
    active_image: MediaObject
  }
}

export const getCelebrities = async (
  client: AxiosInstance,
  { locale }: GetCelebritiesArgs,
): Promise<CelebritiesDto['data']['attributes']> => {
  const path = `/home-page`
  const params = {
    locale,
    fields: ['celebrities_title', 'celebrities_button_text'],
    populate: {
      celebrities: {
        fields: ['name', 'profession', 'short_text', 'full_text'],
        populate: {
          active_image: {
            fields: ['url', 'alternativeText', 'caption'],
          },
        },
      },
    },
  }
  return (await client.get<CelebritiesDto>(path, { params })).data.data.attributes
}
